import {
  Center,
  Flex,
  Grid,
  GridItem,
  Text,
  Box,
  VStack,
  List,
  ListItem,
  Heading,
  Link,
  Button,
  UnorderedList,
} from "@chakra-ui/react";
import { EmailIcon } from "@chakra-ui/icons";
import Fontsize from "../../stylingObjects/FontSize";
import biljartTafelLeeg from "../../assets/images/biljarttafelLeeg.png";
import biljartTafelLeegVert from "../../assets/images/biljarttafelLeegVerticaal.png";
import { TournamentForm } from "../parts/TournamentForm";
import React, { ReactNode, useCallback, useEffect, useState } from "react";
import { TournamentplayersTable } from "../parts/TournamentplayersTable";
import { getLatestTournamentInfo, TournamentType } from "../../service/tournament";
import { TournamentExtraInfo } from "../parts/tournamentInfo";

// Declaration of the StyledListItem component
const StyledListItem: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <ListItem ml={"4px"}>
      <Text fontFamily={"Arial"} fontWeight={900}>
        {children}
      </Text>
    </ListItem>
  );
};

// check if there is a logged in user and if the user has the role 'tournamentadmin' or 'admin'
// if so, show the table with players
const isTournamentAdmin = () => {
  const user = JSON.parse(localStorage.getItem("User") || "{}");
  // console.log("isTournamentAdmin user: ", user);
  if (user.roles) {
    if (
      user.roles.includes("TOURNAMENTADMIN") ||
      user.roles.includes("ADMIN")
    ) {
      // console.log("user is (tournament)admin");
      // console.log("isTournamentAdmin: true");
      return true;
    }
  }
  // console.log("isTournamentAdmin: false");
  return false;
};

export default function TournamentRegistration() {
  // state variable to store the tournament admin status
  const [isTournamentAdminStatus, setIsTournamentAdminStatus] = useState(false);
  const [tournamentInfo, setTournamentInfo] = useState<TournamentType | null>(null);

  const fetchTournamentInfo = useCallback(async () => {
    try {
      const data = await getLatestTournamentInfo();
      if (data) {
        setTournamentInfo(data);
      }
    } catch (error) {
      console.error("Failed to fetch tournament info:", error);
    }
  }, []);

  // Call the function to fetch and set information when the component mounts
  useEffect(() => {
    const isAdmin = isTournamentAdmin();
    setIsTournamentAdminStatus(isAdmin);
    fetchTournamentInfo();
  }, [fetchTournamentInfo]);

  return (
    <>
      <Center>
        <VStack gap={"10px"}>
          <Flex
            bgImage={{ base: biljartTafelLeegVert, sm: biljartTafelLeeg }}
            backgroundSize="contain"
            backgroundRepeat="no-repeat"
            mt="40px"
            width={{
              base: "326px",
              sm: "422px",
              md: "634px",
              lg: "845px",
              xl: "1056px",
            }}
            h={{
              base: "634px",
              sm: "217px",
              md: "326px",
              lg: "435px",
              xl: "544px",
            }}
          >
            <Flex h="90%" w="95%" m="0 auto" alignSelf="center">
              <Grid
                templateAreas={` 
                    "blank1"
                    "form"
                    "blank2"
                  `}
                templateRows="1fr 3fr 1fr"
                w="100%"
              >
                <GridItem></GridItem>

                <GridItem gridArea="form" height="100%" width="100%">
                <TournamentForm tournamentInfo={tournamentInfo} />{" "}
                  {/* comment this line and uncomment below to close the registration */}
                  {/* <VStack>
                    <Text fontFamily={"Arial"} fontWeight={900} pl={4} pr={4}>Toernooi enkelspel.</Text>
                    <Text fontFamily={"Arial"} fontWeight={900} pl={4} pr={4}>15 juli 2023, 13u00. The Corner, Ninove.</Text>
                    <Text fontFamily={"Arial"} fontWeight={900} pl={4} pr={4}>Inschrijvingen gesloten.</Text>
                  </VStack> */}
                </GridItem>
              </Grid>
            </Flex>
          </Flex>
          
          <TournamentExtraInfo tournamentInfo={tournamentInfo} />

          {/* IF THERE IS A LOGGED_IN USER FOR WHOM THE ROLES-ARRAY CONTAINS 'TOURNAMENTADMIN' OR 'ADMIN', SHOW THE TABLE WITH PLAYERS */}
          {isTournamentAdminStatus && (
            <Box>
              <TournamentplayersTable tournamentInfo={tournamentInfo}/>
            </Box>
          )}
        </VStack>
      </Center>
    </>
  );
}
